import {kmApiLink} from "@pg-mono/km-routes";

import axios from "../../km_app/utils/fetch";

export const validateMailingUnsubscribeLink = (emailHash: string, verificationHash: string): Promise<{email: string; email_marketing_consent: boolean}> => {
    return axios.get(kmApiLink.unsubscribe.mailing.base({emailHash, verificationHash})).then((response) => {
        return response.data;
    });
};
import {kmApiLink} from "@pg-mono/km-routes";

import axios from "../../km_app/utils/fetch";

export const validateMailingUnsubscribeLink = (emailHash: string, verificationHash: string): Promise<{email: string; email_marketing_consent: boolean}> => {
    return axios.get(kmApiLink.unsubscribe.mailing.base({emailHash, verificationHash})).then((response) => {
        return response.data;
    });
};
